export default __webpack_public_path__ + "static/media/BN.470ffec9.svg";